export default __webpack_public_path__ + "static/media/back.b57f24db.svg";